var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMailWiki = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0BD42553-8030-4E35-9D1A-772A5C4EE07F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14-wiki--page-Details_With_Page_element",
    transform: "translate(-210.000000, -1387.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-nav",
    transform: "translate(100.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-2",
    transform: "translate(0.000000, 1205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(30.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_mail",
    transform: "translate(79.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,6.17013288 L3,13.5 L15,13.5 L15,6.17013288 L9,11.5034662 L3,6.17013288 Z M4.22264957,5.25 L9,9.49653375 L13.7773504,5.25 L4.22264957,5.25 Z M1.5,15 L1.5,3.75 L16.5,3.75 L16.5,15 L1.5,15 Z",
    id: "shape"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMailWiki);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_mail_wiki.886495d9b376fab44b71ac9dd2fc54b9.svg";